import React from "react";
import "bootstrap/dist/css/bootstrap.css";
import FfrRetryTable from "../components/FfrRetry/FfrRetryTable";

export class FfrRetryContainer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      api: null,
    };
  }

    render() {
        return (
            <div className="container-fluid h-100">
                <div className="row mt-4 justify-content-center">
                    <div className="col-sm-6 mt-5">
                        <FfrRetryTable
                            loggedInUser={this.props.loggedInUser}
                            dcValue={this.props.dcValue}
                        />
                    </div>
                </div>
            </div>
        );
    }
}

export default FfrRetryContainer;
